import TextField from "../components/form/fields/TextField";
import TextAreaField from "../components/form/fields/TextAreaField";
import NumberField from "../components/form/fields/NumberField";
import CurrencyField from "../components/form/fields/CurrencyField";
import PercentageField from "../components/form/fields/PercentageField";
import DateField from "../components/form/fields/DateField";
import DateTimeField from "../components/form/fields/DateTimeField";
import YesNoField from "../components/form/fields/YesNoField";
import RadioField from "../components/form/fields/RadioField";
import CheckboxField from "../components/form/fields/CheckboxField";
import SelectField from "../components/form/fields/SelectField";
import MultiSelectField from "../components/form/fields/MultiSelectField";
import ValueHelpField from "../components/form/fields/ValueHelpField";
import ReadOnlyField from "../components/form/fields/ReadOnlyField";
import CalculatedField from "../components/form/fields/CalculatedField";
import FileUploadField from "../components/form/fields/FileUploadField";
import ExcelUploadField from "../components/form/fields/ExcelUploadField";
import HeadingField from "../components/form/fields/HeadingField";
import InstructionField from "../components/form/fields/InstructionField";
import SeparatorField from "../components/form/fields/SeparatorField";

export const FIELD_COMPONENTS = {
  TEXT: TextField,
  TEXTAREA: TextAreaField,
  NUMBER: NumberField,
  DECIMAL: NumberField,
  CURRENCY: CurrencyField,
  PERCENTAGE: PercentageField,
  DATE: DateField,
  DATETIME: DateTimeField,
  YES_NO: YesNoField,
  RADIO: RadioField,
  CHECKBOX: CheckboxField,
  SELECT: SelectField,
  MULTI_SELECT: MultiSelectField,
  VALUE_HELP: ValueHelpField,
  AUTOCOMPLETE: ValueHelpField,
  READ_ONLY: ReadOnlyField,
  CALCULATED: CalculatedField,
  FILE_UPLOAD: FileUploadField,
  EXCEL_UPLOAD: ExcelUploadField,
  QUESTION_YES_NO: YesNoField,
  QUESTION_SELECT: SelectField,
  HEADING: HeadingField,
  INSTRUCTION: InstructionField,
  SEPARATOR: SeparatorField,
};
